export const permissionsKeys = {
  page: 'micro-sites.institutional-programs.page-block',
  pageBlockFind: 'micro-sites.institutional-programs.page-block.find',
  pageBlockCreateDefault: 'micro-sites.institutional-programs.page-block.createDefault',
  pageBlockUpdate: 'micro-sites.institutional-programs.page-block.update',
  pageBlockPreview: 'micro-sites.institutional-programs.page-block.preview',
  pageBlockUpdateInactivate: 'micro-sites.institutional-programs.inactivate.page-block.update',
  pageBlockUpdateActive: 'micro-sites.institutional-programs.active.page-block.update',
  pageBlockRemove: 'micro-sites.institutional-programs.page-block.remove',
};
